import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Sarah Johnson",
        title: "Lead Trekker",
        biography: "Sarah Johnson is an experienced outdoor guide with a passion for trekking and exploring the wilderness. As the Lead Trekker of our adventure club, she is dedicated to leading thrilling expeditions and ensuring the safety and enjoyment of all participants.",
        contacts: {
            experience: "10 years",
            phone: "111-222-3344",
            email: "sarah.johnson@example.com",
            website: "www.sarahtrekkersguide.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Wilderness Trek Leader",
            "Expedition Organizer",
            "Navigation Specialist",
            "Survival Skills Instructor",
            "Environmental Educator"
        ],
        specialties: [
            { id: 1, title: "Wilderness Trekking", progress: 95 },
            { id: 2, title: "Navigation", progress: 90 },
            { id: 3, title: "Survival Skills", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "John Smith",
        title: "Trail Navigator",
        biography: "John Smith is a skilled trail navigator with extensive knowledge of backcountry routes and remote terrain. With a sharp eye for detail and a deep understanding of the wild, he ensures each journey is accurately mapped and safely guided.",
        contacts: {
            experience: "8 years",
            phone: "222-333-4455",
            email: "john.smith@example.com",
            website: "www.trailguidejohn.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Trail Mapping Expert",
            "Route Planner",
            "Backcountry Guide",
            "Orienteering Coach",
            "Emergency Responder"
        ],
        specialties: [
            { id: 1, title: "Trail Navigation", progress: 92 },
            { id: 2, title: "Route Planning", progress: 88 },
            { id: 3, title: "Emergency Response", progress: 80 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Emma Davis",
        title: "Wilderness Expert",
        biography: "Emma Davis is a seasoned wilderness expert with a deep connection to the natural world. Her expertise in survival techniques, plant identification, and animal tracking makes her an invaluable resource for anyone exploring the great outdoors.",
        contacts: {
            experience: "12 years",
            phone: "333-444-5566",
            email: "emma.davis@example.com",
            website: "www.emmadaviswildlife.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Survival Skills Trainer",
            "Wildlife Tracker",
            "Backcountry Guide",
            "Plant Identification Specialist",
            "Ecotourism Consultant"
        ],
        specialties: [
            { id: 1, title: "Survival Techniques", progress: 97 },
            { id: 2, title: "Wildlife Tracking", progress: 93 },
            { id: 3, title: "Plant Identification", progress: 90 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Mike Roberts",
        title: "Campsite Specialist",
        biography: "Mike Roberts is an expert in campsite setup and outdoor living. With years of experience in creating safe, comfortable, and efficient camping environments, he ensures that every campsite is perfectly tailored to meet the needs of adventurers in the wild.",
        contacts: {
            experience: "15 years",
            phone: "444-555-6677",
            email: "mike.roberts@example.com",
            website: "www.mikecampingexpert.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Campsite Planner",
            "Outdoor Living Specialist",
            "Tent Setup Expert",
            "Fire Safety Advisor",
            "Wilderness First Aid Instructor"
        ],
        specialties: [
            { id: 1, title: "Campsite Setup", progress: 95 },
            { id: 2, title: "Fire Safety", progress: 92 },
            { id: 3, title: "Wilderness First Aid", progress: 90 }
        ]
    }
];

export default team;